<template>
  <div class="component">
    <div class="crm">
      <div class="header">
        <div class="pcAddress">PC端地址</div>
        <div class="pcTips" @click="tipFunction">
          <img src="../../assets/images/common/tip.png" class="pcTipImg">
          如何复制到电脑？
        </div>
      </div>
      <div class="pc_bg">
        <div class="copy">https://www.windhp.com/windhp/market <span class="copy-btn" @click="copy">复制</span> </div>
        <div class="tips">*浏览器打开，微信扫码登录电脑(PC)端，查看更多内容</div>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <div class="dialog">
          <img src="../../assets/images/common/close.png" class="closeImg" @click="show = false">
          <div class="dialog_header">
            如何复制到电脑？
          </div>
          <div class="section">
            <div class="step">
              <img src="../../assets/images/publish/step1.png" class="stepImg">
              <div class="line1"></div>
              <img src="../../assets/images/publish/step2.png" class="stepImg">
              <div class="line2"></div>
              <img src="../../assets/images/publish/step3.png" class="stepImg">
            </div>
            <div class="content">
              <div class="stepContent"> 点击页面中的<span class="colorText">“复制”</span>按钮，复制地址</div>
              <div class="stepContent" style="margin-top: 20px">
                将地址粘贴到手机微信<span class="colorText">“复制”</span>——文件传输助手对话框并发送(或粘贴发送到其他任意对话框)
              </div>
              <div class="stepContent" style="margin-top: 20px">
                在电脑(PC)端微信中<span class="colorText">复制地址，粘贴到电脑(PC)端浏览器中</span>，打开即可
              </div>
            </div>
          </div>
        </div>
      </div>

    </van-overlay>
  </div>

</template>

<script>
export default {
  name: "index",
  data() {
    return {
      show: false,
    };
  },
  methods: {
    copy() {
      this.$copyText("https://www.windhp.com/windhp/market").then(
        () => {
          this.$toast("复制成功");
        },
        () => {
          this.$toast("复制失败");
        }
      );
    },
    // 引导提示
    tipFunction() {
      this.show = true;
    },
    toPublishList() {
      this.$router.push("/myPublish");
    },
  },
};
</script>

<style lang="scss" scoped>
.component {
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .dialog {
      width: 305px;
      height: 220px;
      position: relative;
      background: #ffffff;
      box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
        0px 9px 28px 0px rgba(0, 0, 0, 0.05),
        0px 6px 16px -8px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 22px 20px 30px 16px;
      .closeImg {
        position: absolute;
        width: 30px;
        height: 30px;
        top: 6px;
        right: 6px;
      }
      .dialog_header {
        font-size: 17px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        text-align: center;
      }
      .section {
        margin-top: 18px;
        display: flex;
        flex-direction: row;
        .step {
          display: flex;
          flex-direction: column;
          width: 29px;
          align-items: center;
          .stepImg {
            width: 29px;
            height: 29px;
          }
          .line1 {
            width: 1px;
            margin-top: 3px;
            margin-bottom: 3px;
            height: 13px;
            border-right: 1px dashed rgba(52, 118, 254, 0.3);
          }
          .line2 {
            width: 1px;
            height: 57px;
            margin-top: 3px;
            margin-bottom: 3px;
            border-right: 1px dashed rgba(52, 118, 254, 0.3);
          }
        }
      }
      .content {
        margin-left: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        .colorText {
          color: #3476fe;
        }
        .stepContent {
          line-height: 23px;
        }
      }
    }
  }
}

.crm {
  font-size: 16px;
  color: #333;
  box-sizing: border-box;
  margin-top: 30px;
  padding-top: 10px;
  z-index: -1;
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    .pcAddress {
      background-image: url("../../assets/images/common/pcAddress.png");
      background-size: 100% 100%;
      font-weight: 500;
      color: #ffffff;
      font-size: 14px;
      line-height: 27px;
      padding-left: 10px;
      width: 102px;
      height: 27px;
    }
    .pcTips {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 27px;
      line-height: 27px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3476fe;
      .pcTipImg {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
  }
  .pc_bg {
    margin-left: 20px;
    margin-right: 20px;
    height: 47px;
    padding: 10px;
    background: #ffffff;
    box-shadow: 0px 10px 10px 0px rgba(52, 118, 254, 0.05);
    border-radius: 0px 8px 8px 8px;
    .copy {
      color: #333333;
      font-size: 14px;
      position: relative;
      text-align: left;
      &-btn {
        padding-left: 2px;
        color: #3476fe;
        position: absolute;
        right: 0;
        top: 0;
        display: inline-block;
        background: #ffff;
        text-align: right;
      }
    }
    .tips {
      color: #999999;
      line-height: 17px;
      font-size: 12px;
      margin-top: 6px;
    }
  }
}
</style>
